"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledOption = exports.StyledCheckboxlist = exports.StyledCheckbox = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const styled_1 = require("../icon/styled");
const variants_1 = require("../../themes/variants");
exports.StyledCheckbox = (0, styled_components_1.default)(styled_1.StyledIcon).withConfig({
    shouldForwardProp: (prop) => !["variant", "onChange"].includes(prop),
}) `
  appearance: none;
  margin: 0;
  &[data-testid="checkbox"] {
    font-size: 1.5rem;

    &:before {
      vertical-align: baseline;
    }
    ${(props) => {
    return (0, styled_components_1.css) `
        cursor: pointer;
        transition: color 0.3s;
        color: ${(0, variants_1.variantTextColor)(props)};
      `;
}}
  }
`;
exports.StyledCheckboxlist = styled_components_1.default.section.withConfig({
    shouldForwardProp: (prop) => !["variant"].includes(prop),
}) `
  display: flex;
  flex-direction: ${({ direction }) => direction === "horizontal" ? "row" : "column"};
`;
exports.StyledOption = styled_components_1.default.label.withConfig({
    shouldForwardProp: (prop) => !["variant", "disabled"].includes(prop),
}) `
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  flex: 1;
  display: flex;
  align-items: center;
  line-height: 2rem;
  [data-testid="checkbox"] {
    margin-right: 0.5rem;
    flex: none;
  }
`;
//# sourceMappingURL=styled.js.map